import { createAction } from 'redux-act';

export const setData = createAction('order set data');
export const failGetData = createAction('order fail get data');
export const successGetData = createAction('order success get data');

export const getData = createAction('inquiry get data');
export const putData = createAction('inquiry put data');



// WEBPACK FOOTER //
// ./src/actions/inquiry.js